const firstDividers = [
  {
    paras: [
      'There are four sections to this survey.',
      'No question is compulsory and you can exit the process any time by closing the browser.',
      'The next few questions are about your experiences. Your answers will tell us what is really happening, and where need to act to create change.',
      'At the end of this report, you will be able to confirm your submission and that you give permission for the anonymous data to be used towards a movement of change. ',
    ],
    section: 0,
  },
  {
    paras: [
      'The next few questions are about the harasser(s) / perpetrator(s). Your answers will help us work out what we need to do to create change. ',
    ],
    section: 1,
    explainer: 'All information you provide is confidential.',
  },
  {
    paras: [
      'The following questions explore what the barriers to reporting are and where we need to focus our work to overcome them.',
    ],
    section: 2,
    explainer: 'All information you provide is confidential.',
  },
  {
    paras: [
      'We want to know if certain groups are experiencing sexual harassment disproportionately or in different ways. This helps us to be more specific when tackling the issue and lets us know where to direct our services.',
    ],
    section: 3,
    explainer: 'All information you provide is confidential.',
  },
];

const witnessDividers = [
  {
    paras: [
      'There are four sections to this survey.',
      'No question is compulsory and you can exit the process any time by closing the browser.',
      'The next few questions are about your experiences. Your answers will tell us what is really happening, and where need to act to create change.',
      'At the end of this report, you will be able to confirm your submission and that you give permission for the anonymous data to be used towards a movement of change. ',
    ],
    section: 0,
  },
  {
    paras: [
      'The next few questions are about the harasser(s) / perpetrator(s). Your answers will help us work out what we need to do to create change. ',
    ],
    section: 1,
    explainer: 'All information you provide is confidential.',
  },
  {
    paras: [
      'The following questions explore what the barriers to reporting are and where we need to focus our work to overcome them.',
    ],
    section: 2,
    explainer: 'All information you provide is confidential.',
  },
  {
    paras: [
      'We want to know if certain groups are experiencing sexual harassment disproportionately or in different ways. This helps us to be more specific when tackling the issue and lets us know where to direct our services.',
    ],
    section: 3,
    explainer: 'All information you provide is confidential.',
  },
];

export { firstDividers, witnessDividers };
